export default __webpack_public_path__ + "static/media/aboutus_card_icon1.93284452.svg";